import React from 'react';
import { formatDate } from 'helpers/formatters/date_time_formats';
import Dropdown from 'components/dropdown';
import { Badge } from '@buildoutinc/blueprint-react/ui/Badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClone, faPenToSquare, faStar } from '@fortawesome/pro-regular-svg-icons';
import { faEye, faStar as faStarSolid } from '@fortawesome/pro-solid-svg-icons';
import { BadgeList, UsersAndTeamsCell } from './template_cells';
import type { DocTemplate, TemplateActions } from './types';

type DocTemplateRowProps = TemplateActions & {
  template: DocTemplate,
};

export default function DocTemplateRow({
  template,
  onAccessTemplateReport,
  onDuplicate,
  onDelete,
  onSetDefault
}: DocTemplateRowProps) {
  const canManageDefault = Boolean(template.setDefaultProposalPath);

  return (
    <tr>
      <td className="align-middle">
        <a href={template.editPath}>{template.name}</a>
      </td>
      <td className="align-middle">
        <BadgeList values={template.tags} />
      </td>
      <td className="align-middle">
        <BadgeList values={template.templateType ? [template.templateType] : []} />
      </td>
      <td className="align-middle">
        <BadgeList values={template.propertyTypes} />
      </td>
      <td className="align-middle">
        <UsersAndTeamsCell usersAndTeams={template.usersAndTeams} />
      </td>
      <td className="align-middle">
        {template.createdByName || 'Buildout Defaults'}
      </td>
      <td className="align-middle">
        {formatDate(template.updatedAt)}
      </td>
      <td className="align-middle">
        {template.editedByName || '---'}
      </td>
      <td className="align-middle">
        {template.defaultForSale || template.defaultForLease ? (
          <div className="d-flex gap-1 flex-wrap">
            {template.defaultForSale && <Badge variant="primary">Sale Default</Badge>}
            {template.defaultForLease && <Badge variant="primary">Lease Default</Badge>}
          </div>
        ) : (
          '---'
        )}
      </td>
      <Dropdown.Cell style={{ height: 'auto' }}>
        <Dropdown.Item
          icon={faPenToSquare}
          label="Edit Default"
          onClick={() => {
            window.location.href = template.editPath;
          }}
        />
        <Dropdown.Item
          data-testid="duplicate-template-button"
          icon={faClone}
          label="Duplicate"
          onClick={() => onDuplicate(template)}
        />
        {canManageDefault && (
          <Dropdown.Item
            icon={template.defaultForSale
              ? <FontAwesomeIcon className="text-primary" fixedWidth icon={faStarSolid} />
              : faStar}
            label={template.defaultForSale ? 'Remove default for Sale' : 'Set as default for Sale'}
            onClick={() => onSetDefault(template, 'sale', !template.defaultForSale)}
          />
        )}
        {canManageDefault && (
          <Dropdown.Item
            icon={template.defaultForLease
              ? <FontAwesomeIcon className="text-primary" fixedWidth icon={faStarSolid} />
              : faStar}
            label={template.defaultForLease ? 'Remove default for Lease' : 'Set as default for Lease'}
            onClick={() => onSetDefault(template, 'lease', !template.defaultForLease)}
          />
        )}
        {template.deletePath && (
          <Dropdown.Item
            isDelete
            label="Delete"
            onClick={() => onDelete(template)}
          />
        )}
        {onAccessTemplateReport && (
          <Dropdown.Item
            icon={faEye}
            label="Access Report"
            onClick={() => onAccessTemplateReport(template)}
          />
        )}
      </Dropdown.Cell>
    </tr>
  );
}
